import { ElementRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { NotificacionesPushService } from "app/services/notificaciones-push.service";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "app/shared/confirm-dialog/confirm-dialog.component";
import { PasswordDialogComponent } from "app/shared/password-dialog/password-dialog.component";
import { FotoDialogComponent } from "app/shared/foto-dialog/foto-dialog.component";
import { MedicoService } from "app/services/medico.service";
import { MercadopagoService } from "app/services/mercadopago.service";
import { Medico } from "app/models/medico.interface";
import { UsuarioPanelService } from "app/services/usuario-panel.service";
import { SpinnerService } from "app/services/spinner.service";
import { of } from "rxjs";
import { switchMap, map, catchError } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";

@Component({
  selector: "app-listar-medico",
  templateUrl: "./listar-medico.component.html",
  styleUrls: ["./listar-medico.component.scss"],
})
export class ListarMedicoComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  //
  @ViewChild("divImagen") divImagen: ElementRef;
  @ViewChild("UploadFileInput") uploadFileInput: ElementRef;
  @ViewChild("dropdown2") element: ElementRef;
  @ViewChild("buscador") buscador: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "nombreCompleto",
    "tipo",
    "numeroDoc",
    "matricula",
    "cuentaActivada",
    "sincronizado",
    "acciones",
  ];
  myfilename = "Seleccionar Archivo";
  imagen = "";
  data: any[];
  editar: boolean = false;
  dataSource: any;
  searchKey: string;
  usuarioPanel: any;
  medicoFormulario: any;
  response: any;
  notificacionesPush: any[];

  //
  constructor(
    public dialog: MatDialog,
    public fotoDialog: MatDialog,
    private medicoService: MedicoService,
    private mercadopagoService: MercadopagoService,
    private usuarioPanelService: UsuarioPanelService,
    private spinnerService: SpinnerService,
    private snackBar: MatSnackBar,
  ) {
    this.spinnerService.mostrarSpinner();
    this.usuarioPanelService
      .profileUser()
      .pipe(
        map((data) => {
          this.usuarioPanel = data;
        }),
        catchError((error) => {
          this.spinnerService.ocultarSpinner();
          this.usuarioPanelService.logout();
          return of({ results: null });
        }),
        switchMap((data) =>
          this.medicoService.formularioMedico().pipe(
            map((data: any) => {
              this.response = data;
              this.notificacionesPush = data.notificacionesPush;
              this.listar(this.response.listaMedicos);
              this.spinnerService.ocultarSpinner();
            }),
          ),
        ),
        catchError((error) => {
          this.spinnerService.ocultarSpinner();
          return of({ results: null });
        }),
      )
      .subscribe(
        (data) => {
          console.log("data", data);
        },
        (error) => {
          console.error("Error al llamar a la API:", error);
        },
      );
  }

  //
  ngOnInit(): void {}

  //

  //
  fileChangeEvent(event: any) {
    var target = event.target || event.srcElement;
  }

  //
  listar(data) {
    this.data = data;
    this.data.forEach(function (value) {
      value.celular = value.celPais + value.celCaract + value.celNumero;
    });
    this.data.forEach(function (element) {
      if (element.texto == null || element.texto == "null") element.texto = "";
      if (element.numeroDocumento == null || element.numeroDocumento == "null")
        element.numeroDocumento = "";
    });
    this.dataSource = new MatTableDataSource<Medico>(this.data);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  //
  borrar(medico: Medico) {
    this.spinnerService.mostrarSpinner(); // Mostrar spinner

    this.medicoService.borrar(medico).subscribe(
      () => {
        this.medicoService.listar().subscribe(
          (data) => {
            this.listar(data.listaMedicos);
            this.paginator.firstPage();
            this.spinnerService.ocultarSpinner();
            this.snackBar.open("Médico borrado correctamente", "X", {
              duration: 5000,
              panelClass: ["snackbar"],
            });
          },
          () => {
            this.spinnerService.ocultarSpinner();
            this.snackBar.open("Error al actualizar la lista de médicos", "X", {
              duration: 5000,
              panelClass: ["snackbar", "error"],
            });
          },
        );
      },
      () => {
        this.spinnerService.ocultarSpinner();
        this.snackBar.open("Error al borrar el médico", "X", {
          duration: 5000,
          panelClass: ["snackbar", "error"],
        });
      },
    );
  }

  //
  filter(event) {
    let dataFilter: Medico[] = [];
    let valorString: string = this.buscador.nativeElement.value;
    this.data.forEach((obj) => {
      if (
        obj.nombreCompleto.toUpperCase().includes(valorString.toUpperCase())
      ) {
        dataFilter.push(obj);
      } else if (obj.texto.toUpperCase().includes(valorString.toUpperCase())) {
        dataFilter.push(obj);
      } else if (
        obj.numeroDocumento.toUpperCase().includes(valorString.toUpperCase())
      ) {
        dataFilter.push(obj);
      } else if (
        obj.matricula.toUpperCase().includes(valorString.toUpperCase())
      ) {
        dataFilter.push(obj);
      }
    });
    this.dataSource = new MatTableDataSource<Medico>(dataFilter);
    this.dataSource.paginator = this.paginator;
  }

  //
  listaActualizada(mensaje: boolean) {
    this.medicoService.listar().subscribe(
      (data) => {
        console.log("data", data);
        this.listar(data.listaMedicos);
        this.spinnerService.ocultarSpinner();
      },
      (error) => {
        console.log("error", error);
        this.spinnerService.ocultarSpinner();
      },
    );
  }

  //
  cambiarPassword(id) {
    const dialogRef = this.dialog.open(PasswordDialogComponent, {
      width: "50%",
      data: { nombre: "medico", id: id },
    });

    dialogRef.afterClosed().subscribe((res) => {});
  }

  //
  openDialog(element: Medico) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "50%",
      data: "médico",
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.borrar(element);
      }
    });
  }

  //
  openDialogFoto() {
    const dialogRef = this.fotoDialog.open(FotoDialogComponent, {
      width: "50%",
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (
        res.data.id == "ico_paciente.png" ||
        res.data.id == "ico_pacienteM.png"
      ) {
        this.myfilename = res.data.id;
        this.imagen = "assets/img/" + res.data.id + "";
        this.divImagen.nativeElement.style.display = "block";
      } else {
        this.myfilename = res.data.name;
        this.imagen = res.img;
        this.divImagen.nativeElement.style.display = "block";
      }
    });
  }

  //
  enviarLinkMp(medico: Medico) {
    const yaEnviado = !!medico.mp_last_link_sent_at;
    this.spinnerService.mostrarSpinner();

    this.mercadopagoService.enviarLink(medico.id).subscribe(
      () => {
        this.listaActualizada(true);
        this.snackBar.open(
          yaEnviado
            ? "Link de MercadoPago reenviado. El anterior quedó inválido."
            : "Link de MercadoPago enviado al médico.",
          "X",
          { duration: 5000, panelClass: ["snackbar"] },
        );
      },
      (error) => {
        this.spinnerService.ocultarSpinner();
        this.snackBar.open(
          error.error?.error || "Error al enviar el link de MercadoPago",
          "X",
          { duration: 5000, panelClass: ["snackbar", "error"] },
        );
      },
    );
  }

  //
  desvincularMp(medico: Medico) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "50%",
      data: "vínculo con MercadoPago",
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.spinnerService.mostrarSpinner();
      this.mercadopagoService.desvincular(medico.id).subscribe(
        () => {
          this.listaActualizada(true);
          this.snackBar.open("Médico desvinculado de MercadoPago.", "X", {
            duration: 5000,
            panelClass: ["snackbar"],
          });
        },
        () => {
          this.spinnerService.ocultarSpinner();
          this.snackBar.open("Error al desvincular MercadoPago", "X", {
            duration: 5000,
            panelClass: ["snackbar", "error"],
          });
        },
      );
    });
  }

  //
  reenviarEmailActivacion(medico: Medico) {
    this.spinnerService.mostrarSpinner();

    this.medicoService.reenviarEmailActivacion(medico.id).subscribe(
      (response) => {
        this.spinnerService.ocultarSpinner();
        this.snackBar.open(
          response.mensaje || "Email de activación reenviado correctamente",
          "X",
          {
            duration: 5000,
            panelClass: ["snackbar"],
          },
        );
      },
      (error) => {
        this.spinnerService.ocultarSpinner();
        this.snackBar.open(
          error.error?.mensaje || "Error al reenviar el email de activación",
          "X",
          {
            duration: 5000,
            panelClass: ["snackbar", "error"],
          },
        );
      },
    );
  }
}
